import { Component, ChangeDetectorRef, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { FieldType } from '@ngx-formly/core';
import { ServiceProviderService } from '../../Service/Service-providers/service-provider.service';

@Component({
  selector: 'formly-service-provider-selector',
  template: `
    <div *ngFor="let panel of selectedPanels; let panelIndex = index" class="panel-container">
      <div class="panel-header">
        <span class="panel-title">{{ getServiceProviderTypeName(panel.serviceProviderTypeId) }}</span>
        <button pButton type="button" icon="pi pi-trash" class="remove-btn" 
          (click)="removePanel(panelIndex)">
        </button>
      </div>
      <div class="panel-content">
        <div *ngFor="let group of panel.formArray.controls; let i = index" class="input-container">
          <label>{{ panel.selectedSubTypes[i]?.name }}</label>
          <input type="number" pInputText [formControl]="getFormControl(group, 'count')" 
            class="sub-type-input" (input)="onCountChange(panelIndex, i, $event)" min="0"/>
        </div>
      </div>
    </div>

    <div *ngIf="showError" class="p-error" style="margin-top: 5px;">
    {{ errorMessage }}
    </div>
    <!-- Hide "Add Details" when all service providers are selected -->
    <div class="button-container" *ngIf="filteredServiceProviders.length > 0">
      <button pButton class="Addbutton" type="button" label="Add Details" icon="pi pi-plus" (click)="openDialog()"></button>
    </div>
    

    <p-dialog [(visible)]="isDialogVisible" [modal]="true" class="custom-dialog">
      <ng-template pTemplate="headless">
        <div class="dialog-container">
          <i type="button" (click)="closeDialog()" class='pi pi-times  close-btn'></i>
          <ul class="service-provider-list">
            <li *ngFor="let sp of filteredServiceProviders" (click)="selectServiceProvider(sp)">
              {{ sp.name }}
            </li>
          </ul>
        </div>
      </ng-template>
    </p-dialog>
  `,
  styles: [`
    .close-btn{
      // position:relative;
      // left: -10px;
      // top: -10px
      position: absolute;
      top: 10px;
      right: 10px;
      font-size: 18px;
      color: #344054;
      padding: 8px;
    }
    ::ng-deep .custom-dialog .p-dialog {
      border-radius: 16px !important;
      background: #FFF !important;
      color: #344054 !important;
      padding: 16px;
      width: 400px;
      position: relative;
      box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
    }
    ::ng-deep .custom-dialog .p-dialog-header {
      display: none !important;
    }
    .panel-container {
      // background: #F9FAFB;
      // border: 1px solid #D0D5DD;
      // border-radius: 8px;
      // padding: 16px;
      margin-bottom: 40px;
    }
    .panel-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-weight: 600;
      color: #344054;
     margin-bottom: 20px;
     margin-top: 20px;
    }
    .remove-btn {
      background: red;
      color: white;
      border: none;
      cursor: pointer;
      padding: 8px;
      border-radius: 8px;
      transition: background 0.2s ease-in-out;
    }
    .remove-btn:hover {
      background: darkred;
    }
    .panel-content {
      margin-top: 10px;
      display: flex;
      flex-direction: column;
      gap: 8px;
    }
    .input-container {
      display: flex;
      flex-direction: column;
      gap: 4px;
    }
    .sub-type-input {
      width: 320px;
      height: 44px;
      padding: 10px;
      border-radius: 8px;
      border: 1px solid #D0D5DD;
      background: #FFF;
      color: #344054;
      font-size: 14px;
      outline: none;
      transition: border-color 0.2s ease-in-out;
    }
    .sub-type-input:focus {
      border-color: #344054;
    }
    .button-container {
      margin-top: 0px;
      display: flex;
      justify-content: flex-start;
    }
    .service-provider-list {
      list-style: none;
      padding: 0;
      margin: 8px;
      max-height: 300px;
      overflow-y: auto;
      background: #FFF;
      color: #344054;
      //border-radius: 16px;
    }
    .service-provider-list li {
      padding: 12px;
      cursor: pointer;
      border-bottom: 1px solid #D0D5DD;
      transition: background 0.2s ease-in-out;
    }
    .service-provider-list li:hover {
      background: #FFF1E0;
      //border-color: orange;
    }
    .validation-error {
      color: #d32f2f;
      font-size: 13px;
      margin-top: 4px;
    }
  `]
})
export class ServiceProviderSelectorComponent extends FieldType implements OnInit {
  serviceProviderTypes: any[] = [];
  filteredServiceProviders: any[] = [];
  selectedPanels: { serviceProviderTypeId: number, formArray: FormArray, selectedSubTypes: any[] }[] = [];
  isDialogVisible: boolean = false;

  constructor(private api: ServiceProviderService, private cdr: ChangeDetectorRef, private fb: FormBuilder) {
    super();
  }

  ngOnInit() {
    console.log('selector type is initialized')
    this.fetchServiceProviders();

    if (this.formControl.value && Array.isArray(this.formControl.value)) {
      this.formControl.value.forEach((network: any) => {
        const subTypes = network.distributorNetworkSubType || network.distributorNetworkSubTypes || [];
        const newSubTypes = subTypes.map((sub: any) => ({
          serviceProviderTypeId: network.serviceProviderTypeId,
          subTypeId: sub.serviceProviderSubTypeId,
          name: sub.name,
          count: sub.count || 0
        })
        );
        const newFormArray = new FormArray(
          newSubTypes.map((sub: any) => new FormGroup({
            serviceProviderTypeId: new FormControl(sub.serviceProviderTypeId),
            subTypeId: new FormControl(sub.subTypeId),
            count: new FormControl(sub.count || 0)
          }))
        );

        this.selectedPanels.push({
          serviceProviderTypeId: network.serviceProviderTypeId,
          formArray: newFormArray,
          selectedSubTypes: newSubTypes
        });
      });

      this.updateFilteredProviders();
      this.cdr.detectChanges();
    }
  }


  getFormControl(group: AbstractControl, key: string): FormControl {
    return (group.get(key) as FormControl) ?? new FormControl(0);
  }

  fetchServiceProviders() {
    this.api.getServiceProviderTypes().subscribe({
      next: (data: any[]) => {
        this.serviceProviderTypes = data;
        this.updateFilteredProviders();
        this.cdr.detectChanges();
      },
      error: (err) => console.error("Failed to fetch service providers:", err),
    });
  }

  openDialog() {
    this.updateFilteredProviders();
    this.isDialogVisible = true;
  }

  selectServiceProvider(sp: any) {
    const newSubTypes = sp.serviceProviderSubType.map((sub: any) => ({
      serviceProviderTypeId: sp.serviceProviderTypeId,
      subTypeId: sub.serviceProviderSubTypeId,
      name: sub.name,
      count: 0
    }));

    const newFormArray = new FormArray(
      newSubTypes.map((sub: any) => new FormGroup({
        serviceProviderTypeId: new FormControl(sub.serviceProviderTypeId),
        subTypeId: new FormControl(sub.subTypeId),
        count: new FormControl(sub.count || 0)
      }))
    );

    this.selectedPanels.push({
      serviceProviderTypeId: sp.serviceProviderTypeId,
      formArray: newFormArray,
      selectedSubTypes: newSubTypes
    });

    this.updateFormlyModel();
    this.updateFilteredProviders();
    this.isDialogVisible = false;
    this.cdr.detectChanges();
  }

  removePanel(index: number) {
    this.selectedPanels.splice(index, 1);
    this.updateFormlyModel();
    this.updateFilteredProviders();
    this.cdr.detectChanges();
  }
  updateFormlyModel() {
    this.formControl.setValue(this.selectedPanels.map(panel => ({
      serviceProviderTypeId: panel.serviceProviderTypeId,
      distributorNetworkSubType: panel.selectedSubTypes.map((sub, i) => ({
        serviceProviderSubTypeId: sub.subTypeId,
        count: panel.formArray.at(i)?.value.count || 0
      }))
    })));
  }


  onCountChange(panelIndex: number, subIndex: number, event: Event) {
    const inputElement = event.target as HTMLInputElement;
    if (inputElement) {
      const parsedValue = Number(inputElement.value);
      if (!isNaN(parsedValue) && parsedValue >= 0) {
        this.selectedPanels[panelIndex].formArray.at(subIndex)?.patchValue({ count: parsedValue });

        this.formControl.setValue(this.selectedPanels.map(panel => ({
          serviceProviderTypeId: panel.serviceProviderTypeId,
          distributorNetworkSubType: panel.selectedSubTypes.map((sub, i) => ({
            serviceProviderSubTypeId: sub.subTypeId,
            count: panel.formArray.at(i)?.value.count || 0
          }))
        })));
      }
    }
  }

  getServiceProviderTypeName(serviceProviderTypeId: number): string {
    const serviceProvider = this.serviceProviderTypes.find(sp => sp.serviceProviderTypeId === serviceProviderTypeId);
    return serviceProvider ? serviceProvider.name : 'Selected Service Provider Type';
  }

  updateFilteredProviders() {
    const selectedTypeIds = this.selectedPanels.map(panel => panel.serviceProviderTypeId);
    this.filteredServiceProviders = this.serviceProviderTypes.filter(sp =>
      !selectedTypeIds.includes(sp.serviceProviderTypeId)
    );
  }

  closeDialog() {
    this.isDialogVisible = false;
  }

  override get showError(): boolean {
    return this.formControl?.invalid && this.formControl?.touched;
  }

  get errorMessage(): string | null {
    const errors = this.formControl?.errors;
    if (!errors) return null;

    const messages = this.to?.['validation']?.messages || {};
    const firstKey = Object.keys(errors)[0];
    const defaultMsg = messages?.[firstKey];

    return typeof defaultMsg === 'function'
      ? defaultMsg(errors[firstKey], this.field)
      : defaultMsg || 'Invalid field';
  }

}
